/*
* DialogPlayerContentEvent.js
* Created on 9-3-2021
* @author reinier@ranj.nl
*/

import NGTScenarioPlayer from "../NGTScenarioPlayer";

export default class ScenarioPlayerRegisterEvent {
    /**
     * @param {String} type 
     * @param {NGTScenarioPlayer} scenarioPlayer 
     */
    constructor(type, scenarioPlayer) {
        this.type = type;
        this.scenarioPlayer = scenarioPlayer;
    }
}

ScenarioPlayerRegisterEvent.REGISTER = "ScenarioPlayerRegisterEvent.REGISTER";
ScenarioPlayerRegisterEvent.DEREGISTER = "ScenarioPlayerRegisterEvent.DEREGISTER";